import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const ErrorPage = Loadable({
  loader: () => import('./ErrorPage'),
  loading: Loading
});

export default [
  {
    path: '/error-page',
    component: ErrorPage
  }
];



// WEBPACK FOOTER //
// ./src/errorPage/routers.js